var map = {
	"./LINK_2x.svg": "44dc",
	"./MINIPROGRAM_2x.svg": "7375",
	"./VIDEO_2x.svg": "2ef3",
	"./default_2x.svg": "2333",
	"./excel_2x.svg": "c765",
	"./pdf_2x.svg": "cd05c",
	"./ppt_2x.svg": "ce76",
	"./word_2x.svg": "de56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f47d";